import router from '@/router';

let ringtone = new Audio('./cute-ringtone-44287.mp3');

export default {
  namespaced: true,
  state: {
    status: 'IDLE',
    flat: null, //current flat communication
    gateway: null, //current gateway  communication
    push: null
  },
  mutations: {
    setStatus(state, payload) {
      state.status = payload;
    },
    setFlat(state, payload) {
      state.flat = payload;
    },
    setGateway(state, payload) {
      state.gateway = payload;
    },
    setPush: (state, data) => {
      console.log('Setting incoming push to', data);
      state.push = data;
    }
  },
  actions: {
    setStatus(context, data) {
      context.commit('setStatus', data);
      if (data == 'INCOMING') {
        //context.dispatch('setRingtone', true);
      } else {
        console.log('Tryingm 2');
        //context.dispatch('setRingtone', false);
      }
    },
    setPush: (context, data) => {
      context.commit('setPush', data);

      if (data) {
        context.dispatch('setStatus', 'INCOMING');
        if ('Flat' in data) {
          context.commit('setGateway', data.Flat.split('/')[0]);
          context.commit('setFlat', data.Flat.split('/')[1]);
        }

        console.log(context);
        context.dispatch('flats/fetch', null, { root: true }).then(gateways => {
          for (let i = 0; i < gateways.length; i++) {
            if (gateways[i].flat == data.Flat) {
              let target = '/incoming/' + i;
              console.log('Router try to go to path ' + target);
              router.push({ path: target, params: { state: 'incoming' } });

              break;
            }
          }
        });
      } else {
        context.dispatch('setStatus', 'IDLE');
        context.commit('setGateway', null);
        context.commit('setFlat', null);
      }
    },
    setRingtone(context, play) {
      console.log('Going to set ringtone to' + play);
      ringtone.load();
      if (play) {
        console.log('Going to playiing ringtone');
        ringtone.loop = true;
        let promise = ringtone.play();
        if (promise !== undefined) {
          promise
            .then(_ => {
              console.log('Playing started');
            })
            .catch(error => {
              console.error(error);
            });
        }
      }
    },
    ['awsauth/setUser']: {
      root: true,
      handler({ dispatch, commit }, user) {}
    }
  }
};
